import type { CISProviderBehavior } from '../types';

export const actCISBehavior: CISProviderBehavior = {
	label: 'ACT',
	getTestPanelConfig() {
		return { show: true, altText: 'ACT' };
	},
};
